export type TagTone = "neutral" | "primary" | "success" | "warning" | "danger" | "accent" | "mark";

/** Antd-Farb- und Statusnamen auf die Töne der Stile abbilden — bestehende `color`-Werte bleiben gültig. */
const COLOR_TONES: Record<string, TagTone> = {
  default: "neutral",
  success: "success",
  green: "success",
  lime: "success",
  processing: "primary",
  blue: "primary",
  cyan: "primary",
  geekblue: "primary",
  warning: "warning",
  gold: "mark",
  orange: "warning",
  yellow: "mark",
  error: "danger",
  red: "danger",
  volcano: "danger",
  magenta: "accent",
  purple: "accent",
  pink: "accent",
};
const TONES = new Set<string>(["neutral", "primary", "success", "warning", "danger", "accent", "mark"]);

/** Ton zu `color` (Kit-Ton oder Antd-Name); ohne Angabe neutral, freie Farbe `undefined`. */
export function resolveTagTone(color: string | undefined): TagTone | undefined {
  if (!color) return "neutral";
  return COLOR_TONES[color] ?? (TONES.has(color) ? (color as TagTone) : undefined);
}
